import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps"


const AccountAutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label = "Certificate Account", load = true, disabled = false, selectFirst = false, infoText, error, helperText}) => {
    return (
        <AsyncAutoCompleteContained
            label={label}
            url="/autocompleteApi/GetCertificateAccounts"
            valueId={valueId}
            load={load}
            onChange={onChange}
            disabled={disabled}
            selectFirst={selectFirst}
            infoText={infoText}
            error={error}
            helperText={helperText}
        />
    );
};

export default AccountAutoComplete;
